import React from "react";
import Header from "./common/Header";
import Sidebar from "./common/Sidebar";

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = (props) => {
  return (
    <div className="page-wrapper h-100">
      <Sidebar />
      <div className="page-wrapper-body">
        <Header />
        <main className="main-content">{props?.children}</main>
      </div>
    </div>
  );
};

export default MainLayout;
